// import React from "react";
// import { Grid, Typography } from "@material-ui/core";
// import { makeStyles } from "@material-ui/core";
// import Nav from './Nav';


// const useStyle = makeStyles((theme) => ({
//   main: {
//     padding: "20px",
//   },
//   cards: {
//     display: "flex",
//     justifyContent: "space-evenly",
//     cursor: "pointer",
//   },

//   container: {
//     boxShadow: " 0 15px 20px rgba(0, 0, 0, 0.1)",
//     "&:hover": {
//       boxShadow: " 0 5px 15px rgba(0, 0, 0, 0.2)",
//     },
//     padding: "15px",
//     width: "250px",
//     margin: "20px",
//   },
//   image: {
//     height: "150px",
//     width: "220px",
//   },
//   datelogo: {
//     paddingTop: "18px",
//     height: "40px",
//     width: "20px",
//   },
//   datecontainer: {
//     display: "flex",
//   },
//   videoTitle: {
//     marginTop: 0,
//     color: "hsl(205,78%,33%)",
//   },
// }));

// const News = () => {
//   const classes = useStyle();
//   return (
//     <div className={classes.main}>
//       <Nav></Nav>
//       <div>
//         <Typography
//           variant="h5"
//           style={{
//             color: "hsl(205,78%,33%)",
//             display: "flex",
//             justifyContent: "center",
//             margin: "2% 0",
//           }}
//         >
//           Videos
//         </Typography>

//         <p
//           style={{
//             marginTop: 0,
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//           }}
//         >
//           MOT members are actively engaged in different activities, This page
//           shows the different videos.
//         </p>
//       </div>
//       <div className={classes.cards}>
//         <Grid className={classes.container}>
//         <video controls className={classes.image} >
//       <source src="/motvideo1.mp4" type="video/mp4"/>
//      </video>
//           <div className={classes.datecontainer}>
//             <img
//               src="https://img.icons8.com/small/32/000000/timeline-week.png"
//               alt="date"
//               className={classes.datelogo}
//             />
//             <p style={{ paddingTop: "16px", paddingLeft: "5px" }}>1 jan 2021</p>
//           </div>
//           <div className={classes.videoTitle}>
//             <b style={{ fontWeight: "20rem" }}>Oxygen plant installation</b>
//           </div>
//         </Grid>

//         <Grid className={classes.container}>
//         <video controls className={classes.image} >
//       <source src="/motvideo2.mp4" type="video/mp4"/>
//      </video>
//           <div className={classes.datecontainer}>
//             <img
//               src="https://img.icons8.com/small/32/000000/timeline-week.png"
//               alt="date"
//               className={classes.datelogo}
//             />
//             <p style={{ paddingTop: "16px", paddingLeft: "5px" }}>1 jan 2021</p>
//           </div>
//           <div className={classes.videoTitle}>
//             <b style={{ fontWeight: "20rem" }}>Oxygen plant installation</b>
//           </div>
//         </Grid>
//         <Grid className={classes.container}>
//         <video controls className={classes.image} >
//       <source src="/motvideo3.mp4" type="video/mp4"/>
//      </video>
//           <div className={classes.datecontainer}>
//             <img
//               src="https://img.icons8.com/small/32/000000/timeline-week.png"
//               alt="date"
//               className={classes.datelogo}
//             />
//             <p style={{ paddingTop: "16px", paddingLeft: "5px" }}>1 jan 2021</p>
//           </div>
//           <div className={classes.videoTitle}>
//             <b style={{ fontWeight: "20rem" }}>Oxygen plant installation</b>
//           </div>
//         </Grid>
//         <Grid className={classes.container}>
//         <video controls className={classes.image} >
//       <source src="/motvideo2.mp4" type="video/mp4"/>
//      </video>
//           <div className={classes.datecontainer}>
//             <img
//               src="https://img.icons8.com/small/32/000000/timeline-week.png"
//               alt="date"
//               className={classes.datelogo}
//             />
//             <p style={{ paddingTop: "16px", paddingLeft: "5px" }}>1 jan 2021</p>
//           </div>
//           <div className={classes.videoTitle}>
//             <b style={{ fontWeight: "20rem" }}>Oxygen plant installation</b>
//           </div>
//         </Grid>
//       </div>
//     </div>
//   );
// };

// export default News;


import React from "react";
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";
import Nav from './Nav';

const useStyle = makeStyles((theme) => ({
  main: {
    padding: "30px",
  },
  cards: {
    display: "flex",

    flexWrap: "wrap",
    justifyContent: "space-evenly",
    cursor: "pointer",
  },

  container: {
    boxShadow: " 0 15px 20px rgba(0, 0, 0, 0.1)",
    "&:hover": {
      boxShadow: " 0 5px 15px rgba(0, 0, 0, 0.2)",
    },
    padding: "15px",
    width: "250px",
    margin: "20px",
  },
  image: {
    height: "150px",
    width: "220px",
  },
  datelogo: {
    paddingTop: "18px",
    height: "40px",
    width: "20px",
  },
  datecontainer: {
    display: "flex",
  },
  newsTitle: {
    color: "hsl(205,78%,33%)",
  },
}));

const News = () => {
  const classes = useStyle();
  return (
    <div className={classes.main}>
      <Nav></Nav>
      <div>
        <Typography
          variant="h5"
          style={{
            color: "hsl(205,78%,33%)",
            display: "flex",
            justifyContent: "center",
            margin: "2% 0",
          }}
        >
          Videos
        </Typography>

        <p
          style={{
            marginTop: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          MOT members are actively engaged in different activities, This page
           shows the different videos.
        </p>
      </div>
      <div className={classes.cards}>
        <div className={classes.container}>
        <video autoPlay muted loop className={classes.image} >
       <source src="/motvideo4.mp4" type="video/mp4"/>
   </video>
          <div className={classes.datecontainer}>
            <img
              src="https://img.icons8.com/small/32/000000/date-span.png"
              alt="date"
              className={classes.datelogo}
            />
            <p style={{ paddingTop: "15px" }}> 25 Aug 2022</p>
          </div>
          <div className={classes.newsTitle}>
            <b style={{ fontWeight: "20rem" }}><a href="https://www.facebook.com/1534091168/videos/pcb.10228681883582026/1080117289549613">MOT Training</a></b>
          </div>
        </div>

        <div className={classes.container}>
        <video autoPlay muted loop className={classes.image} >
       <source src="/motvideo2.mp4" type="video/mp4"/>
   </video>
          <div className={classes.datecontainer}>
            <img
              src="https://img.icons8.com/small/32/000000/date-span.png"
              alt="date"
              className={classes.datelogo}
            />
            <p style={{ paddingTop: "15px" }}> 21 july 2022</p>
          </div>
          <div className={classes.newsTitle}>
            <b style={{ fontWeight: "20rem" }}><a href="https://www.facebook.com/missionoxygenteam/" >MOT Training</a> </b>
          </div>
        </div>

        <div className={classes.container}>
        <video autoPlay muted loop className={classes.image} >
       <source src="/motvideo3.mp4" type="video/mp4"/>
   </video>
          <div className={classes.datecontainer}>
            <img
              src="https://img.icons8.com/small/32/000000/date-span.png"
              alt="date"
              className={classes.datelogo}
            />
            <p style={{ paddingTop: "15px" }}> 21 july 2022</p>
          </div>
          <div className={classes.newsTitle}>
            <b style={{ fontWeight: "20rem" }}><a href="https://www.facebook.com/missionoxygenteam/" >MOT Training</a></b>
          </div>
        </div>
        <div className={classes.container}>
        <video autoPlay muted loop className={classes.image} >
       <source src="/motvideo4.mp4" type="video/mp4"/>
   </video>
          <div className={classes.datecontainer}>
            <img
              src="https://img.icons8.com/small/32/000000/date-span.png"
              alt="date"
              className={classes.datelogo}
            />
            <p style={{ paddingTop: "15px" }}> 21 july 2022</p>
          </div>
          <div className={classes.newsTitle}>
            <b style={{ fontWeight: "20rem" }}><a href="https://www.facebook.com/missionoxygenteam/" >MOT Training</a></b>
          </div>
        </div>
        
      </div>
    </div>
  );
};

export default News;
